export default {
  "club_currency_not_configured": "Moneda del club sin configurar",
  "please_configure_a_currency_in_control_to_view_cost_comparisons": "Configure una moneda en Control para ver las comparaciones de costes.",
  "currency_lookup_failed": "No se pudo consultar la moneda",
  "defaulted_to_gbp_until_the_currency_service_is_available": "Se utilizará GBP hasta que el servicio de moneda esté disponible.",
  "failed_to_load_budgets": "No se pudieron cargar los presupuestos",
  "failed_to_load_budget_references": "No se pudieron cargar las referencias presupuestarias",
  "sent_to_budget": "Enviado a Presupuestos",
  "budget_line_created_for_board_approval": "Partida presupuestaria creada para la aprobación de la junta.",
  "failed_to_send_to_budget": "No se pudo enviar a Presupuestos",
  "failed_to_award_rfq": "No se pudo adjudicar la RFQ",
  "cost_advantage": "Ventaja de coste",
  "quality_advantage": "Ventaja de calidad",
  "service_advantage": "Ventaja de servicio",
  "head_to_head_bidder_battle": "Comparación directa de licitadores",
  "select_rfq_to_compare": "Seleccione una RFQ para comparar",
  "cost_weight": "Peso del coste",
  "quality_weight": "Peso de la calidad",
  "service_weight": "Peso del servicio",
  "total_weight": "Peso total:",
  "total_weight_must_be_100_currently": "El peso total debe ser ≤ 100 %. Actualmente",
  "reduce_by": "% (reduzca en",
  "reset_to_template": "Restablecer plantilla",
  "set_at_least_one_weight_above_0_to_run_the_comparison": "Establezca al menos un peso superior al 0 % para ejecutar la comparación.",
  "calculating": "Calculando...",
  "run_battle_analysis": "Ejecutar análisis comparativo",
  "calculating_battle_outcome": "Calculando el resultado de la comparación...",
  "winner": "Ganador",
  "tie": "Empate",
  "lead_margin": "Margen de ventaja",
  "biggest_differentiator": "Principal diferencia",
  "challenger_a": "Licitador A",
  "winner_32": "GANADOR",
  "tie_33": "EMPATE",
  "total_cost": "Coste total",
  "final_score_10": "Puntuación final (/10)",
  "evaluate": "Evaluar",
  "cost_score": "Puntuación de coste:",
  "quality_score": "Puntuación de calidad:",
  "service_score": "Puntuación de servicio:",
  "unknown": "Desconocido",
  "send_to_budget": "Enviar a Presupuestos",
  "awarding": "Adjudicando...",
  "award": "Adjudicar",
  "this_rfq_was_sent_to_budget_with_a_different_bid": "Esta RFQ se envió a Presupuestos con otra oferta.",
  "challenger_b": "Licitador B",
  "awaiting_submissions": "Esperando ofertas",
  "awaiting_more_bidder_submissions_for_this_rfq": "Se esperan más ofertas de licitadores para esta RFQ.",
  "category_breakdown": "Desglose por categoría",
  "quality_score_49": "Puntuación de calidad",
  "service_score_50": "Puntuación de servicio",
  "ready_for_battle": "Todo listo para comparar",
  "no_submissions_available_yet_for_the_selected_rfq": "Todavía no hay ofertas disponibles para la RFQ seleccionada.",
  "select_an_rfq_with_multiple_submissions_to_start_the_head_to_head": "Seleccione una RFQ con varias ofertas para iniciar la comparación directa",
  "no_rfqs_available": "No hay RFQ disponibles",
  "there_are_no_rfqs_to_compare_please_create_or_import_rfqs_to_use_": "No hay RFQ para comparar. Cree o importe RFQ para utilizar esta función.",
  "award_without_board_approval": "¿Adjudicar sin aprobación de la junta?",
  "are_you_sure_board_approval_is_not_required_for_awarding_this_bid": "¿Confirma que no se necesita la aprobación de la junta para adjudicar esta oferta? Esta acción quedará registrada.",
  "cancel": "Cancelar",
  "yes_award_anyway": "Sí, adjudicar de todos modos",
  "select_an_existing_budget_to_create_a_board_approved_earmark": "Seleccione un presupuesto existente para crear una reserva aprobada por la junta.",
  "budget": "Presupuesto",
  "no_budgets_available": "No hay presupuestos disponibles",
  "gl_account": "Cuenta contable",
  "department": "Departamento",
  "owner_optional": "Responsable (opcional)",
  "search_staff_by_name_or_email": "Buscar personal por nombre o correo electrónico",
  "unassigned": "Sin asignar",
  "searching": "Buscando...",
  "no_matches": "Sin coincidencias",
  "type_at_least_2_characters_to_search": "Escriba al menos 2 caracteres para buscar.",
  "searching_staff": "Buscando personal...",
  "select_a_staff_member_to_assign_ownership": "Seleccione un miembro del personal como responsable.",
  "category": "Categoría",
  "total_amount": "Importe total",
  "currency": "Moneda:",
  "month_allocation": "Distribución mensual",
  "single_month_charge": "Cargo en un solo mes",
  "split_across_months": "Repartir entre meses",
  "month": "Mes",
  "amount": "Importe",
  "remove": "Eliminar",
  "add_month": "Añadir mes",
  "allocated_total": "Total distribuido:",
  "allocation_total_must_match_the_total_amount": "El total distribuido debe coincidir con el importe total.",
  "sending": "Enviando...",
  "contract_renewal_alerts": "Alertas de renovación de contratos",
  "ai_powered_contract_renewal_predictions_and_recommendations": "Predicciones y recomendaciones de renovación de contratos con IA",
  "critical": "Crítico",
  "refresh": "Actualizar",
  "upcoming_renewals": "Próximas renovaciones",
  "next_30_days": "Próximos 30 días",
  "critical_risk": "Riesgo crítico",
  "require_attention": "Requieren atención",
  "total_value": "Valor total",
  "annual_contracts": "Contratos anuales",
  "avg_performance": "Rendimiento medio",
  "out_of_100": "de 100",
  "all_contracts": "Todos los contratos",
  "risk": "Riesgo",
  "contract": "Contrato",
  "contract_ends": "Fin del contrato",
  "days_to_decide": "días para decidir",
  "current_value": "Valor actual",
  "predicted_increase": "% de aumento previsto",
  "performance_score": "Puntuación de rendimiento",
  "alternatives": "Alternativas",
  "bidders": "licitadores",
  "ai_recommendation": "Recomendación de IA:",
  "risk_factors": "Factores de riesgo:",
  "last_review": "Última revisión:",
  "start_negotiation": "Iniciar negociación",
  "schedule_review": "Programar revisión",
  "no_contract_renewals": "Sin renovaciones de contratos",
  "no_contracts_match_the_selected_risk_level": "Ningún contrato coincide con el nivel de riesgo seleccionado.",
  "usda_market_news": "USDA Market News",
  "food_agricultural_commodities": "Productos alimentarios y agrícolas",
  "eia_energy_data": "Datos energéticos de EIA",
  "fuel_prices_and_energy_costs": "Precios de combustible y costes energéticos",
  "bureau_of_labor_statistics": "Bureau of Labor Statistics",
  "cpi_ppi_indices_for_service_categories": "Índices IPC/IPP para categorías de servicios",
  "wine_searcher": "Wine-Searcher",
  "global_wine_pricing_database": "Base de datos mundial de precios del vino",
  "liv_ex": "Liv-ex",
  "fine_wine_trading_platform": "Plataforma de comercio de vinos de alta gama",
  "mintec": "Mintec",
  "food_ingredient_pricing": "Precios de ingredientes alimentarios",
  "opis": "OPIS",
  "intraday_fuel_pricing": "Precios intradía del combustible",
  "price_index_data_sources": "Fuentes de datos del índice de precios",
  "core_data_sources": "Fuentes de datos básicas",
  "included": "Incluido",
  "updates": "Actualizaciones:",
  "enhanced_data_sources": "Fuentes de datos ampliadas",
  "available": "Disponible",
  "premium_feature": "Función prémium",
  "enhanced_data_sources_provide_deeper_market_intelligence_with_rea": "Las fuentes de datos ampliadas ofrecen información de mercado más detallada con precios en tiempo real, categorías especializadas y análisis avanzados. Contacte con su representante de Privana para activar estas fuentes prémium.",
  "data_sources_update_automatically_changes_take_effect_within_1_ho": "Las fuentes de datos se actualizan automáticamente. Los cambios se aplican en un plazo de 1 hora.",
  "save_settings": "Guardar configuración",
  "failed_to_load_bidders": "No se pudieron cargar los licitadores",
  "all_bidders": "Todos los licitadores",
  "master_directory_of_vendors_across_all_rfqs": "Directorio general de proveedores de todas las RFQ",
  "search_by_name_or_email": "Buscar por nombre o correo electrónico",
  "status": "Estado",
  "all": "Todos",
  "active": "Activo",
  "inactive": "Inactivo",
  "name": "Nombre",
  "contact": "Contacto",
  "email": "Correo electrónico",
  "website": "Sitio web",
  "phone": "Teléfono",
  "last_updated": "Última actualización",
  "loading_bidders": "Cargando licitadores...",
  "no_bidders_found": "No se encontraron licitadores.",
  "showing_0_bidders": "Mostrando 0 licitadores",
  "previous": "Anterior",
  "next": "Siguiente",
  "active_rfqs": "RFQ activas",
  "data_unavailable": "Datos no disponibles",
  "total_submissions": "Total de ofertas",
  "submitted_bids": "ofertas presentadas",
  "club_currency": "moneda del club",
  "avg_response_time": "Tiempo medio de respuesta",
  "to_submission": "hasta la presentación",
  "cost_savings_vs_budget": "Ahorro frente al presupuesto",
  "weighted_across_rfqs": "ponderado entre las RFQ",
  "urgent_rfqs": "RFQ urgentes",
  "no_urgent_rfqs": "Sin RFQ urgentes",
  "no_deadline": "Sin fecha límite",
  "recent_activity": "Actividad reciente",
  "no_recent_activity": "Sin actividad reciente",
  "rfq_processing_time": "Tiempo de tramitación de RFQ",
  "average_response_time": "tiempo medio de respuesta",
  "bidder_participation": "Participación de licitadores",
  "avg_submissions_per_rfq": "media de ofertas por RFQ",
  "cost_savings": "Ahorro de costes",
  "vs_budgeted_amounts": "frente a los importes presupuestados",
  "bidder_performance_heatmap": "Mapa de rendimiento de licitadores",
  "high_risk_only": "Solo riesgo alto",
  "medium_risk_only": "Solo riesgo medio",
  "low_risk_only": "Solo riesgo bajo",
  "avg_lead_time": "Plazo medio de entrega",
  "days": "días",
  "avg_price_variance": "Variación media de precios",
  "avg_reliability": "Fiabilidad media",
  "high_risk": "Riesgo alto",
  "risk_188": "riesgo",
  "lead_time": "Plazo de entrega:",
  "price_variance": "Variación de precios:",
  "reliability": "Fiabilidad:",
  "sla_breaches": "Incumplimientos del SLA:",
  "risk_193": "Riesgo:",
  "heat_score": "Índice de riesgo:",
  "no_bidder_data": "Sin datos de licitadores",
  "click_generate_demo_data_to_see_bidder_locations_and_performance_": "Haga clic en «Generar datos de demostración» para ver las ubicaciones y métricas de rendimiento de los licitadores",
  "legend": "Leyenda",
  "low_risk_bidders": "Licitadores de riesgo bajo",
  "medium_risk_bidders": "Licitadores de riesgo medio",
  "high_risk_bidders": "Licitadores de riesgo alto",
  "circle_size_indicates_heat_score_larger_higher_risk_variance": "El tamaño del círculo indica el índice de riesgo (más grande = mayor riesgo/variación)",
  "new_procurement_request": "Nueva solicitud de compra",
  "request_title": "Título de la solicitud *",
  "brief_description_of_what_you_need": "Descripción breve de lo que necesita",
  "detailed_description": "Descripción detallada *",
  "provide_detailed_requirements_specifications_quantities_etc": "Indique requisitos detallados, especificaciones, cantidades, etc.",
  "your_department": "Su departamento",
  "select_category": "Seleccione una categoría",
  "products": "Productos",
  "services": "Servicios",
  "maintenance": "Mantenimiento",
  "technology": "Tecnología",
  "food_beverage": "Alimentos y bebidas",
  "other": "Otros",
  "estimated_budget": "Presupuesto estimado",
  "required_by_date": "Fecha requerida",
  "urgency": "Urgencia",
  "low": "Baja",
  "medium": "Media",
  "high": "Alta",
  "urgent": "Urgente",
  "submit_request": "Enviar solicitud",
  "unable_to_generate_rfq": "No se pudo generar la RFQ",
  "ai_powered_rfq_builder": "Creador de RFQ con IA",
  "describe_your_procurement_need": "Describa su necesidad de compra",
  "what_do_you_need_be_as_specific_as_possible": "¿Qué necesita? (Sea lo más específico posible)",
  "e_g_we_need_a_weekly_linen_service_for_our_dining_room_including_": "P. ej.: «Necesitamos un servicio semanal de mantelería para nuestro comedor, con manteles, servilletas y paños de cocina. Atendemos unos 300 comensales por semana y necesitamos calidad superior con garantía de eliminación de manchas el mismo día...»",
  "ai_will_help_you_with": "La IA le ayudará con:",
  "professional_rfq_structure_and_language": "• Estructura y redacción profesional de la RFQ",
  "industry_specific_requirements_and_compliance": "• Requisitos y cumplimiento específicos del sector",
  "evaluation_criteria_recommendations": "• Recomendaciones de criterios de evaluación",
  "contract_terms_suggestions": "• Sugerencias de condiciones contractuales",
  "line_item_specifications": "• Especificaciones de las partidas",
  "ai_generated_rfq_review_edit": "RFQ generada con IA: revisar y editar",
  "title": "Título",
  "description": "Descripción",
  "urgent_rfq": "RFQ urgente",
  "flag_for_expedited_procurement_review": "Marcar para revisión prioritaria de compras.",
  "link_budget_line_staff_only": "Vincular partida presupuestaria (solo personal)",
  "clear_selection": "Borrar selección",
  "budget_amounts_remain_hidden_from_bidders": "Los importes presupuestarios permanecen ocultos para los licitadores.",
  "line_items": "Partidas",
  "add_item": "Añadir partida",
  "item_name": "Nombre de la partida",
  "unit_of_measure": "Unidad de medida",
  "e_g_each_kg_hours": "P. ej.: unidad, kg, horas",
  "quantity": "Cantidad",
  "est_unit_cost": "Coste unitario estimado ($)",
  "specifications": "Especificaciones",
  "detailed_specifications_quality_requirements_etc": "Especificaciones detalladas, requisitos de calidad, etc.",
  "rfq_summary": "Resumen de la RFQ",
  "urgent_252": "Urgente:",
  "yes": "Sí",
  "budget_line": "Partida presupuestaria:",
  "line_items_255": "Partidas (",
  "generating": "Generando...",
  "generate_rfq": "Generar RFQ",
  "review_publish": "Revisar y publicar",
  "create_rfq": "Crear RFQ",
  "cost": "Coste",
  "quality": "Calidad",
  "service": "Servicio",
  "failed_to_load_rfq": "No se pudo cargar la RFQ",
  "please_configure_a_currency_in_control_before_creating_submission": "Configure una moneda en Control antes de crear ofertas.",
  "bidder_invited_no_email_sent": "Licitador invitado (sin envío de correo)",
  "invite_created_email_failed": "Invitación creada (falló el correo)",
  "failed_to_invite_bidder": "No se pudo invitar al licitador",
  "bidder_name_is_required": "El nombre del licitador es obligatorio",
  "failed_to_create_bidder": "No se pudo crear el licitador",
  "status_updated": "Estado actualizado",
  "failed_to_update_status": "No se pudo actualizar el estado",
  "scoring_template_updated": "Plantilla de puntuación actualizada",
  "failed_to_update_scoring_template": "No se pudo actualizar la plantilla de puntuación",
  "enter_scores_before_saving": "Introduzca las puntuaciones antes de guardar",
  "evaluation_saved": "Evaluación guardada",
  "failed_to_save_evaluation": "No se pudo guardar la evaluación",
  "select_a_bidder_first": "Seleccione primero un licitador",
  "please_configure_a_currency_before_creating_submissions": "Configure una moneda antes de crear ofertas.",
  "submission_saved": "Oferta guardada",
  "failed_to_save_submission": "No se pudo guardar la oferta",
  "failed_to_promote_supplier": "No se pudo convertir en proveedor",
  "portal_link_copied": "Enlace del portal copiado",
  "failed_to_copy_portal_link": "No se pudo copiar el enlace del portal",
  "portal_link_regenerated": "Enlace del portal regenerado",
  "failed_to_regenerate_link": "No se pudo regenerar el enlace",
  "failed_to_send_invite_email": "No se pudo enviar el correo de invitación",
  "rfq_detail": "Detalle de la RFQ",
  "back_to_list": "Volver a la lista",
  "loading_rfq_details": "Cargando detalles de la RFQ...",
  "rfq_not_found": "RFQ no encontrada.",
  "uncategorized": "Sin categoría",
  "created": "· Creada",
  "invited": "· Invitados",
  "submitted": "· Ofertas presentadas",
  "overview": "Resumen",
  "bidders_296": "Licitadores",
  "submissions": "Ofertas",
  "evaluation": "Evaluación",
  "activity": "Actividad",
  "deadline": "Fecha límite:",
  "type": "Tipo",
  "set_status": "Establecer estado",
  "awarded": "Adjudicada",
  "awarded_bidder": "Licitador adjudicatario",
  "view_supplier": "Ver proveedor",
  "promote_to_supplier": "Convertir en proveedor",
  "award_this_rfq_to_promote_the_winning_bidder_into_the_suppliers_m": "Adjudique esta RFQ para convertir al licitador ganador en proveedor en el módulo Proveedores.",
  "invited_bidders": "Licitadores invitados",
  "invited_309": "invitados",
  "search_bidders": "Buscar licitadores",
  "invite": "Invitar",
  "add_a_new_bidder": "Añadir un licitador nuevo",
  "bidder_name": "Nombre del licitador",
  "email_optional": "Correo electrónico (opcional)",
  "create_invite": "Crear e invitar",
  "no_bidders_invited_yet": "Todavía no hay licitadores invitados.",
  "status_317": "Estado:",
  "submitted_318": "Presentada",
  "more_details": "Más detalles",
  "last_viewed": "Última visita",
  "link_expires": "El enlace caduca",
  "revoked": "Este enlace de invitación ha sido revocado. Solicite un nuevo enlace al club.",
  "invite_email_sent": "Correo de invitación enviado",
  "invite_email_failed": "Error del correo de invitación:",
  "submission_confirmation_sent": "Confirmación de oferta enviada",
  "submission_confirmation_failed": "Error de la confirmación de oferta:",
  "copy_link": "Copiar enlace",
  "regenerate_link": "Regenerar enlace",
  "send_invite_email": "Enviar correo de invitación",
  "received": "recibidas",
  "bidder": "Licitador",
  "select_invited_bidder": "Seleccione un licitador invitado",
  "notes": "Notas",
  "currency_334": "Moneda",
  "club_currency_not_configured_submissions_are_disabled": "Moneda del club sin configurar. Las ofertas están deshabilitadas.",
  "upload_quote_pdf": "Subir oferta (PDF)",
  "saving": "Guardando...",
  "save_submission": "Guardar oferta",
  "no_submissions_yet": "Todavía no hay ofertas.",
  "awarded_bid": "Oferta adjudicada",
  "no_notes": "Sin notas",
  "view": "Ver",
  "scoring_template": "Plantilla de puntuación",
  "weight": "Peso (%)",
  "save_template": "Guardar plantilla",
  "weights_must_add_up_to_100": "Los pesos deben sumar el 100 %.",
  "no_submissions_available_to_evaluate": "No hay ofertas disponibles para evaluar.",
  "total_score": "Puntuación total:",
  "needs_evaluation": "Pendiente de evaluación",
  "cost_rating_0_10": "Puntuación de coste (0–10)",
  "quality_rating_0_10": "Puntuación de calidad (0–10)",
  "service_rating_0_10": "Puntuación de servicio (0–10)",
  "save_evaluation": "Guardar evaluación",
  "requires_board_approved_budget": "Requiere un presupuesto aprobado por la junta.",
  "computed_total": "Total calculado:",
  "linked_to_budget": "Vinculado al presupuesto",
  "no_budget_linked_yet_use_evaluation_to_send_a_bid_to_budget": "Todavía no hay presupuesto vinculado. Use Evaluación para enviar una oferta a Presupuestos.",
  "no_activity_yet": "Todavía no hay actividad.",
  "this_will_create_a_supplier_record_from_the_awarded_bidder_and_li": "Se creará un registro de proveedor a partir del licitador adjudicatario y se vinculará a esta RFQ.",
  "also_create_a_contract_for_renewals": "Crear también un contrato para renovaciones",
  "optional_contract_details_will_be_attached_to_the_new_supplier": "Los detalles opcionales del contrato se adjuntarán al nuevo proveedor.",
  "contract_name": "Nombre del contrato",
  "start_date": "Fecha de inicio",
  "end_date": "Fecha de fin",
  "renewal_type": "Tipo de renovación",
  "notice_period_days": "Días de preaviso",
  "value": "Valor",
  "promoting": "Convirtiendo...",
  "confirm": "Confirmar",
  "submission": "Oferta",
  "previous_371": "← Anterior",
  "of": "de",
  "next_373": "Siguiente →",
  "pricing_summary": "Resumen de precios",
  "lead_time_375": "Plazo de entrega",
  "validity_date": "Fecha de validez",
  "no_notes_provided": "Sin notas.",
  "exclusions": "Exclusiones",
  "assumptions": "Supuestos",
  "attachments": "Adjuntos",
  "copy_bidder_portal_link": "Copiar enlace del portal de licitadores",
  "download": "Descargar",
  "no_files_attached": "Sin archivos adjuntos.",
  "last_updated_384": "Última actualización",
  "failed_to_load_rfqs": "No se pudieron cargar las RFQ",
  "rfq_status_updated": "Estado de la RFQ actualizado",
  "requests_for_quotation_rfqs": "Solicitudes de cotización (RFQ)",
  "loading_rfqs": "Cargando RFQ...",
  "invited_389": "Invitados:",
  "submitted_390": "Ofertas presentadas:",
  "created_391": "Creada:",
  "invite_more_bidders": "Invitar a más licitadores",
  "send_to_bidders": "Enviar a licitadores",
  "view_details": "Ver detalles",
  "change_status": "Cambiar estado",
  "no_rfqs_found": "No se encontraron RFQ.",
  "real_time_price_index": "Índice de precios en tiempo real",
  "live_usda_food_commodity_pricing_and_bidder_comparisons": "Precios de productos alimentarios de USDA en directo y comparaciones con licitadores",
  "usda_live_data": "Datos de USDA en directo",
  "updating": "Actualizando...",
  "price_index_enhanced_coming_soon": "Índice de precios ampliado próximamente",
  "more_categories_with_premium_data_feeds_fuel_linens_wine_technolo": "- Más categorías con fuentes de datos prémium (combustible, mantelería, vino, tecnología).",
  "price_alerts": "alertas de precios:",
  "significant_price_movements_detected_in": "Se detectaron movimientos de precios significativos en",
  "5_week_trend_flow": "Tendencia de 5 semanas",
  "select_an_item_below_to_view_its_5_week_price_trend": "Seleccione un artículo a continuación para ver su tendencia de precios de 5 semanas.",
  "all_categories": "Todas las categorías",
  "no_live_data": "Sin datos en directo",
  "vs": "frente a $",
  "vs_club_actual": "frente al coste real del club",
  "club_pays": "El club paga: $",
  "volatility": "Volatilidad",
  "awaiting_next_usda_update": "Esperando la próxima actualización de USDA",
  "data_sources_schedule": "Fuentes de datos y calendario:",
  "usda_market_news_service": "USDA Market News Service",
  "last_updated_416": "Última actualización:",
  "next_update": "Próxima actualización:",
  "updates_automatically_every_monday_at_8_00_am_local_time_or_click": "Se actualiza automáticamente cada lunes a las 8:00, hora local, o pulse Actualizar para actualizar de inmediato.",
  "enhanced_available": "Ampliación disponible",
  "contact_support_for_fuel_wine_linens_more": "Contacte con soporte para combustible, vino, mantelería y más",
  "no_usda_price_data_available": "No hay datos de precios de USDA disponibles",
  "click_refresh_to_load_current_usda_commodity_pricing_data": "Pulse Actualizar para cargar los precios actuales de productos de USDA.",
  "load_usda_data": "Cargar datos de USDA",
  "unable_to_prepare_invitation_emails": "No se pudieron preparar los correos de invitación",
  "review_bidder_emails": "Revisar correos de licitadores",
  "source": "Origen",
  "existing_bidder": "Licitador existente",
  "new_bidder": "Nuevo licitador",
  "search_all_bidders": "Buscar en todos los licitadores",
  "type_at_least_2_characters": "Escriba al menos 2 caracteres",
  "no_email": "sin correo electrónico",
  "company_name": "Nombre de la empresa",
  "contact_first_name": "Nombre del contacto",
  "contact_last_name": "Apellidos del contacto",
  "existing_bidder_contact_details_are_read_only_here_edit_the_canon": "Los datos de contacto del licitador existente son de solo lectura aquí. Edite el registro original en Todos los licitadores antes de preparar esta invitación.",
  "this_bidder_or_email_is_already_selected": "Este licitador o correo electrónico ya está seleccionado.",
  "add_bidder": "Añadir licitador",
  "your_microsoft_mailbox_is_not_available_connect_or_reconnect_it_i": "Su buzón de Microsoft no está disponible. Conéctelo o vuelva a conectarlo en Comunicaciones antes de enviar. Privana no utilizará el correo del sistema como alternativa.",
  "generating_drafts_creates_the_canonical_rfq_bidder_relationship_s": "Al generar borradores se crea la relación entre la RFQ y el licitador, por lo que el recuento de invitados puede aumentar antes de enviar el correo. Los estados de borrador, enviado y entrega fallida se registran por separado.",
  "generate_email_drafts": "Generar borradores de correo",
  "from": "De",
  "to": "Para",
  "recipient_is_tied_to_the_selected_canonical_bidder_contact_edit_t": "El destinatario está vinculado al contacto original del licitador seleccionado. Edite el licitador en Todos los licitadores para cambiarlo.",
  "subject": "Asunto",
  "body": "Cuerpo",
  "include_online_quote_submission_link": "Incluir enlace de presentación de ofertas en línea",
  "adds_a_secure_privana_link_to_this_email_so_the_bidder_can_submit": "Añade un enlace seguro de Privana a este correo para que el licitador presente su oferta directamente en esta RFQ. Desactívelo si prefiere que el licitador responda o envíe su oferta por correo electrónico.",
  "retry_this_recipient": "Reintentar para este destinatario",
  "reconciliation_pending": "conciliación pendiente",
  "recheck_delivery": "Comprobar entrega",
  "send_this_email": "Enviar este correo",
  "sent": "enviados",
  "close": "Cerrar",
  "retry_unsent_recipients": "Reintentar destinatarios pendientes",
  "send_all_emails": "Enviar todos los correos",
  "professional": "Profesional",
  "formal_and_business_like": "Formal y empresarial",
  "friendly": "Cercano",
  "warm_and_collaborative": "Cálido y colaborativo",
  "stern": "Firme",
  "firm_and_direct": "Firme y directo",
  "diplomatic": "Diplomático",
  "tactful_and_careful": "Prudente y cuidadoso",
  "video_call": "Videollamada",
  "phone_call": "Llamada telefónica",
  "in_person_meeting": "Reunión presencial",
  "start_negotiation_469": "Iniciar negociación -",
  "schedule_review_470": "Programar revisión -",
  "recipients": "Destinatarios",
  "bidder_contacts": "Contactos del licitador",
  "primary": "Principal",
  "cc_staff_members": "Personal en copia",
  "cc_custom_emails": "Correos personalizados en copia",
  "enter_email_address": "Introduzca una dirección de correo electrónico",
  "email_content": "Contenido del correo",
  "tone": "Tono",
  "meeting_type": "Tipo de reunión",
  "generate_ai_content": "Generar contenido con IA",
  "email_subject": "Asunto del correo",
  "message": "Mensaje",
  "compose_your_email_message": "Redacte su mensaje de correo electrónico...",
  "send_email": "Enviar correo",
  "bidder_portal": "Portal de licitadores",
  "external_bidder_access_is_now_available": "El acceso para licitadores externos ya está disponible.",
  "bidder_portal_enabled": "Portal de licitadores habilitado",
  "external_bidder_access_is_enabled_from_rfq_detail_via_invite_link": "El acceso para licitadores externos se habilita desde el detalle de la RFQ mediante enlaces de invitación.",
  "jan": "ene",
  "feb": "feb",
  "mar": "mar",
  "apr": "abr",
  "may": "may",
  "jun": "jun",
  "jul": "jul",
  "aug": "ago",
  "sep": "sep",
  "oct": "oct",
  "nov": "nov",
  "dec": "dic",
  "operating": "Operativo",
  "capex": "Inversiones",
  "select_gl_account": "Seleccione una cuenta contable",
  "failed_to_load_procurement_data": "No se pudieron cargar los datos de compras",
  "failed_to_create_rfq": "No se pudo crear la RFQ",
  "create_professional_rfqs_with_ai_assistance": "Cree RFQ profesionales con la ayuda de IA",
  "start_new_rfq": "Iniciar nueva RFQ",
  "phase_1": "Fase 1",
  "missing_required_fields": "Faltan campos obligatorios",
  "contact_name_email_total_amount_and_currency_are_required_to_subm": "El nombre del contacto, el correo electrónico, el importe total y la moneda son obligatorios para presentar la oferta.",
  "submission_locked": "Oferta bloqueada",
  "this_offer_has_already_been_submitted_and_can_no_longer_be_edited": "Esta oferta ya se ha presentado y no se puede editar.",
  "deadline_passed": "Plazo vencido",
  "the_submission_deadline_has_passed_please_contact_the_club": "El plazo de presentación ha vencido. Contacte con el club.",
  "file_uploaded": "Archivo subido",
  "file_upload_failed": "No se pudo subir el archivo",
  "loading_invitation": "Cargando invitación...",
  "bidder_submission_portal": "Portal de presentación de ofertas",
  "request_for_quote": "Solicitud de cotización",
  "category_520": "Categoría:",
  "type_521": "· Tipo:",
  "company": "Empresa:",
  "your_offer_is_locked_editing_is_unavailable": "Su oferta está bloqueada. No se puede editar.",
  "contact_name": "Nombre del contacto",
  "contact_email": "Correo electrónico del contacto",
  "total_price": "Precio total",
  "currency_is_not_configured_please_contact_the_club_before_submitt": "La moneda no está configurada. Contacte con el club antes de presentar la oferta.",
  "lead_time_days": "Plazo de entrega (días)",
  "validity_until": "Válida hasta",
  "accepted_pdf_images_word_documents_or_text_files_max_10mb": "Formatos admitidos: PDF, imágenes, documentos Word o archivos de texto (máx. 10 MB).",
  "save_draft": "Guardar borrador",
  "submit_offer": "Presentar oferta",
  "retry": "Inténtelo de nuevo.",
  "serverError": "No se pudo completar la operación. Inténtelo de nuevo.",
  "budgetUnknown": "Estado del presupuesto desconocido (actualice).",
  "awardedOverride": "Adjudicada (excepción)",
  "rfqAwarded": "RFQ adjudicada",
  "budgetLoading": "Cargando presupuestos...",
  "budgetSelect": "Seleccione un presupuesto",
  "budgetLinesLoading": "Cargando partidas presupuestarias…",
  "budgetLineSelect": "Seleccione una partida presupuestaria",
  "budgetLineSearch": "Buscar partidas presupuestarias...",
  "budgetLineError": "No se pudieron cargar las partidas presupuestarias.",
  "budgetLinesEmpty": "No se encontraron partidas presupuestarias.",
  "retryMoment": "Inténtelo de nuevo en unos instantes.",
  "no": "No",
  "submittedSuccessfully": "Oferta presentada correctamente",
  "draftSaved": "Borrador guardado",
  "offerSubmitted": "Su oferta se ha presentado al club.",
  "draftReturn": "Puede volver a actualizar este borrador en cualquier momento antes de la fecha límite.",
  "submissionFailed": "No se pudo presentar la oferta",
  "draftFailed": "No se pudo guardar el borrador",
  "expired": "Este enlace de invitación ha caducado. Solicite un nuevo enlace al club.",
  "invalid": "Este enlace de invitación no es válido o no está disponible.",
  "reconciling": "Se está conciliando la entrega de Microsoft. Privana no reenviará hasta conocer el resultado del proveedor.",
  "sendFailed": "No se pudo enviar",
  "supplierLinked": "Proveedor ya vinculado",
  "supplierCreated": "Proveedor creado",
  "copied": "Enlace copiado al portapapeles.",
  "newCopied": "Nuevo enlace copiado al portapapeles.",
  "selectGl": "Seleccione una cuenta contable",
  "searchGl": "Buscar cuentas contables...",
  "emptyGl": "No se encontraron cuentas contables.",
  "selectDepartment": "Seleccione un departamento",
  "searchDepartment": "Buscar departamentos...",
  "emptyDepartment": "No se encontraron departamentos.",
  "primaryContact": "Contacto principal",
  "selectRecipient": "Seleccione al menos un contacto del licitador al que enviar el correo.",
  "emailFailed": "No se pudo enviar el correo. Inténtelo de nuevo.",
  "enter": "Introducir",
  "showing": "Mostrando {start}–{end} de {total} licitadores",
  "daysValue": "{count} días",
  "due": "Vence: {date}",
  "publishedActivity": "RFQ publicada: {title}",
  "submissionActivity": "Oferta de {name}",
  "regenerateConfirm": "¿Regenerar el enlace del portal para {name}? El enlace anterior dejará de funcionar.",
  "expires": "Caduca el {date}",
  "newExpires": "El nuevo enlace caduca el {date}",
  "inviteEmailed": "Invitación enviada por correo a {recipient}",
  "toRecipient": " a {recipient}",
  "emailSent": "Correo enviado correctamente a {count} destinatarios.",
  "negotiationSubject": "Negociación de contrato - {name}",
  "reviewSubject": "Reunión de revisión de contrato - {name}",
  "portalUnavailable": "El acceso de licitadores no está disponible. Contacte con el club.",
  "enums": {
    "status": {
      "draft": "Borrador",
      "published": "Publicada",
      "collecting_quotes": "Recogiendo ofertas",
      "evaluation": "Evaluación",
      "awarded": "Adjudicada",
      "closed": "Cerrada",
      "cancelled": "Cancelada",
      "active": "Activo",
      "inactive": "Inactivo",
      "submitted": "Presentada",
      "invited": "Invitado",
      "viewed": "Vista",
      "pending": "Pendiente",
      "sent": "Enviado",
      "failed": "Fallido",
      "sending": "Enviando",
      "reconciling": "Conciliando",
      "reconciliation_pending": "Conciliación pendiente",
      "board_approved": "Aprobado por la junta",
      "approved": "Aprobado",
      "open": "Abierta",
      "rejected": "Rechazada",
      "expired": "Caducada",
      "revoked": "Revocada",
      "reconciliation pending": "Conciliación pendiente"
    },
    "risk": {
      "critical": "Crítico",
      "high": "Alto",
      "medium": "Medio",
      "low": "Bajo",
      "unknown": "Desconocido"
    },
    "recommendation": {
      "renew": "Renovar",
      "renegotiate": "Renegociar",
      "replace": "Sustituir",
      "review": "Revisar"
    },
    "category": {
      "products": "Productos",
      "services": "Servicios",
      "maintenance": "Mantenimiento",
      "technology": "Tecnología",
      "food_beverage": "Alimentos y bebidas",
      "linen_laundry": "Mantelería y lavandería",
      "landscaping": "Jardinería",
      "security": "Seguridad",
      "other": "Otros",
      "Operating": "Operativo",
      "CapEx": "Inversiones"
    },
    "criterion": {
      "cost": "Coste",
      "quality": "Calidad",
      "service": "Servicio"
    },
    "activity": {
      "RFQIssued": "RFQ emitida",
      "RFQUpdated": "RFQ actualizada",
      "RFQSubmissionReceived": "Oferta recibida",
      "RFQSubmissionEvaluated": "Oferta evaluada",
      "RFQAwarded": "RFQ adjudicada",
      "portal_link_generated": "Enlace del portal generado",
      "portal_link_regenerated": "Enlace del portal regenerado",
      "created": "RFQ creada",
      "updated": "RFQ actualizada",
      "status_changed": "Estado cambiado",
      "bidder_invited": "Licitador invitado",
      "bidder_invite_email_sent": "Correo de invitación enviado al licitador",
      "bidder_invitation_email_sent": "Correo de invitación enviado al licitador",
      "bidder_invitation_email_failed": "Error del correo de invitación al licitador",
      "bidder_promoted_to_supplier": "Licitador convertido en proveedor",
      "bidder_submission_file_uploaded": "Adjunto del licitador subido",
      "budget_link_removed": "Vínculo presupuestario eliminado",
      "rfq_awarded": "RFQ adjudicada",
      "rfq_awarded_without_board_approval": "RFQ adjudicada sin aprobación de la junta",
      "sent_to_budget": "Enviado a Presupuestos",
      "submission_created": "Oferta creada",
      "submission_evaluated": "Oferta evaluada",
      "submission_file_uploaded": "Adjunto de la oferta subido"
    },
    "market": {
      "Beef": "Vacuno",
      "Pork": "Cerdo",
      "Poultry": "Aves",
      "Dairy": "Lácteos",
      "Fruits": "Frutas",
      "Vegetables": "Verduras",
      "Ribeye": "Entrecot",
      "Striploin": "Lomo bajo",
      "Tenderloin": "Solomillo",
      "Bacon": "Beicon",
      "Loins": "Lomos",
      "Hams": "Jamones",
      "Boneless Breast": "Pechuga deshuesada",
      "Wings": "Alitas",
      "Whole Broilers": "Pollos enteros",
      "Butter": "Mantequilla",
      "Cheddar": "Cheddar",
      "Milk": "Leche",
      "Apples": "Manzanas",
      "Grapes": "Uvas",
      "Strawberries": "Fresas",
      "Lettuce": "Lechuga",
      "Tomatoes": "Tomates",
      "Onions": "Cebollas",
      "Food": "Alimentación",
      "Fuel": "Combustible",
      "Energy": "Energía",
      "Linens": "Mantelería",
      "Maintenance": "Mantenimiento",
      "Services": "Servicios",
      "Wine": "Vino",
      "Spirits": "Bebidas espirituosas",
      "Premium Wine": "Vinos de alta gama",
      "Investment Wine": "Vinos de inversión",
      "Food Ingredients": "Ingredientes alimentarios",
      "Packaging": "Envases",
      "Meat": "Carne"
    },
    "schedule": {
      "Hourly": "Cada hora",
      "Daily": "A diario",
      "Monthly": "Mensualmente",
      "Real-time": "En tiempo real",
      "Intraday": "Intradía"
    },
    "region": {
      "US Markets": "Mercados de EE. UU.",
      "National & Regional": "Nacional y regional",
      "US Economic Data": "Datos económicos de EE. UU.",
      "Global": "Mundial",
      "Global Fine Wine": "Vinos de alta gama mundiales",
      "Global Food Supply": "Suministro alimentario mundial",
      "Regional Fuel Markets": "Mercados regionales de combustible"
    },
    "trend": {
      "rising": "Al alza",
      "falling": "A la baja",
      "stable": "Estable"
    },
    "unit": {
      "lb": "lb",
      "cwt": "cwt",
      "bag": "saco",
      "carton": "caja"
    }
  },
  "outbound": {
    "greeting": "Hola,",
    "greetingName": "Hola {name},",
    "submit": "Presente su oferta",
    "questions": "Si tiene alguna pregunta, responda a este correo.",
    "deadline": "Fecha límite de presentación: {date}",
    "inviteSubject": "Invitación a presentar una oferta: {title}",
    "inviteBody": "Le invitamos a presentar una oferta para {number}: {title}.",
    "submitHere": "Presente su oferta aquí: {url}",
    "receivedSubject": "Oferta recibida — {label}",
    "receivedBody": "Hemos recibido su oferta para {label}.",
    "thanks": "Gracias por presentar su respuesta. Nuestro equipo la revisará y se pondrá en contacto con usted si necesita más información.",
    "draftSubject": "Solicitud de cotización: {number} — {title}",
    "draftBody": "Invitamos a {name} a presentar una oferta para {number}: {title}.",
    "responseNotification": "{name} ha respondido a su RFQ: {title}"
  },
  "errors": {
    "ai_invalid_json": "No se pudo leer la RFQ generada. Inténtelo de nuevo.",
    "ai_invalid_response": "La RFQ generada está incompleta. Inténtelo de nuevo.",
    "award_submission_not_budgeted": "La oferta seleccionada no coincide con la oferta presupuestada.",
    "bidder_not_found": "No se encontró el licitador.",
    "budget_line_not_found": "No se encontró la partida presupuestaria.",
    "budget_missing_current_version": "Este presupuesto no tiene una versión vigente.",
    "budget_not_board_approved": "El presupuesto requiere la aprobación de la junta.",
    "budget_not_found": "No se encontró el presupuesto.",
    "budget_submission_missing": "Seleccione una oferta para enviar a Presupuestos.",
    "club_currency_fetch_failed": "No se pudo cargar la moneda del club.",
    "club_identity_unavailable": "La información del club no está disponible.",
    "currency_mismatch": "La moneda de la oferta debe coincidir con la moneda del club.",
    "description_required": "La descripción es obligatoria.",
    "draft_not_found": "No se encontró el borrador de invitación.",
    "duplicate_or_invalid_bidder": "Un licitador seleccionado no es válido o está duplicado.",
    "file_not_found": "No se encontró el archivo.",
    "file_too_large": "El archivo supera el límite de tamaño permitido.",
    "file_upload_failed": "No se pudo subir el archivo.",
    "invalid_bidders": "Seleccione licitadores válidos.",
    "invalid_budget_line_id": "Seleccione una partida presupuestaria válida.",
    "invalid_club_code": "No se pudo identificar el club.",
    "invalid_contact_email": "Introduzca una dirección de correo de contacto válida.",
    "invalid_criteria": "Revise los criterios de evaluación.",
    "invalid_file_type": "Este tipo de archivo no está admitido.",
    "invalid_limit": "El tamaño de página solicitado no es válido.",
    "invalid_multipart": "No se pudo leer el archivo. Selecciónelo de nuevo.",
    "invalid_offset": "La página solicitada no es válida.",
    "invalid_request": "Revise el formulario e inténtelo de nuevo.",
    "invalid_scores": "Compruebe que las puntuaciones estén dentro del intervalo permitido.",
    "invalid_status": "Seleccione un estado válido.",
    "invalid_status_transition": "Este cambio de estado no está permitido.",
    "invite_not_found": "No se encontró la invitación.",
    "mailbox_changed_regenerate_drafts": "Su buzón ha cambiado. Vuelva a generar los borradores de invitación.",
    "missing_bidder_email": "Añada una dirección de correo para este licitador.",
    "missing_file": "Seleccione un archivo para subir.",
    "missing_required_fields": "Complete los campos obligatorios.",
    "name_required": "El nombre del licitador es obligatorio.",
    "need_text_required": "Describa su necesidad de compra.",
    "need_text_too_long": "La necesidad de compra no debe superar los 4000 caracteres.",
    "no_updates": "No se proporcionaron cambios.",
    "rate_limit_exceeded": "Demasiadas solicitudes. Inténtelo de nuevo más tarde.",
    "rate_limited": "Demasiadas solicitudes. Inténtelo de nuevo más tarde.",
    "recipient_must_match_bidder_contact": "El destinatario debe coincidir con el contacto del licitador seleccionado.",
    "rfq_already_awarded": "Esta RFQ ya se ha adjudicado.",
    "rfq_already_sent_to_budget": "Esta RFQ ya se ha enviado a Presupuestos.",
    "rfq_not_accepting_submissions": "Esta RFQ no acepta ofertas.",
    "rfq_not_awarded": "Adjudique esta RFQ antes de convertir al licitador en proveedor.",
    "rfq_not_eligible": "Esta RFQ no admite esta acción.",
    "rfq_not_found": "No se encontró la RFQ.",
    "rfq_not_sent_to_budget": "Envíe primero esta RFQ a Presupuestos.",
    "scoring_template_not_found": "No se encontró la plantilla de puntuación.",
    "send_in_progress": "Este correo ya se está enviando.",
    "send_reconciliation_pending": "Se está comprobando la entrega. Espere antes de reintentar.",
    "send_reconciliation_required": "Debe comprobarse la entrega antes de reintentar.",
    "submission_failed": "No se pudo presentar la oferta. Inténtelo de nuevo.",
    "submission_not_found": "No se encontró la oferta.",
    "submission_rfq_mismatch": "Esta oferta pertenece a otra RFQ.",
    "weights_must_sum_to_100": "Los pesos de evaluación deben sumar el 100 %."
  },
  "newActions": {
    "review": "Programar reunión de revisión de rendimiento",
    "research": "Investigar licitadores alternativos",
    "negotiate": "Preparar estrategia de negociación",
    "terms": "Revisar las condiciones del contrato"
  },
  "contractDefault": "{rfq} Contrato adjudicado",
  "dayValue": "{count} día",
  "showingOne": "Mostrando {start}–{end} de {total} licitador",
  "emailSentOne": "Correo enviado correctamente a {count} destinatario."
};
